import React from "react";
import { CardComp, TableCompData } from "../../../components";
import { formatMoney } from "../../../utils";
import { summarizeSchedule, summaryFacts } from "../../../components/Loan/scheduleModel";
import "../../../components/Loan/loan.css";

/**
 * Formal (schedule-based) loan calculator result table.
 * Columns: S/N, Period, Opening, Payment, Interest, Principal, Closing.
 */
const FormalLoanCalculationResult = ({ data }) => {
  const columns = [
    {
      name: "S/N",
      selector: (_, index) => <span className="text-muted">{index + 1}</span>,
      width: "70px",
    },
    {
      name: "Period",
      selector: (row) => <span>{row?.repayment_type ?? "—"}</span>,
    },
    {
      name: "Opening balance",
      selector: (row) => (
        <span>{formatMoney(Number(row?.starting_balance ?? 0).toFixed(2))}</span>
      ),
    },
    {
      name: "Payment",
      selector: (row) => (
        <span>
          {formatMoney(
            Number(row?.payment ?? row?.amount ?? 0).toFixed(2)
          )}
        </span>
      ),
    },
    {
      name: "Interest",
      selector: (row) => (
        <span>{formatMoney(Number(row?.interest ?? 0).toFixed(2))}</span>
      ),
    },
    {
      name: "Principal",
      selector: (row) => (
        <span>{formatMoney(Number(row?.principal ?? 0).toFixed(2))}</span>
      ),
    },
    {
      name: "Closing balance",
      selector: (row) => (
        <span>{formatMoney(Number(row?.ending_balance ?? 0).toFixed(2))}</span>
      ),
    },
  ];

  const rows = Array.isArray(data) ? data : [];
  const facts = summaryFacts(summarizeSchedule(rows));

  return (
    <CardComp cardClassName="border-0 pt-4 pb-5">
      {facts.length ? (
        <section className="lt" aria-label="Schedule summary" style={{ marginBottom: 16 }}>
          <dl className="lt-facts">
            {facts.map((f) => (
              <div key={f.key} className="lt-fact">
                <dt>{f.label}</dt>
                <dd>{f.value}</dd>
              </div>
            ))}
          </dl>
        </section>
      ) : null}
      <TableCompData
        marginBottom="1rem"
        columns={columns}
        data={rows}
        defaultSortFieldId={false}
        message=""
      />
    </CardComp>
  );
};

export default FormalLoanCalculationResult;
